<template>
    <div>
        <vx-card title="Medical Information" subtitle="Lists of Medical Information"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewMedical()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeMedical">
                    <template slot="thead">
                        <vs-th>Date</vs-th>
                        <vs-th>No of Days</vs-th>
                        <vs-th>Doctor's Name</vs-th>
                        <vs-th>Hospital/Clinic</vs-th>
                        <vs-th>In-Patient?</vs-th>
                        <vs-th>Complaints</vs-th>
                        <vs-th>Diagnosis</vs-th>
                        <vs-th>Medical Procedure</vs-th>
                        <vs-th>Results</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].dateMedical">
                                {{ data[indextr].dateMedical | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].noofDays">
                                {{ data[indextr].noofDays }}
                            </vs-td>
                            <vs-td :data="data[indextr].doctorName">
                                {{ data[indextr].doctorName }}
                            </vs-td>
                            <vs-td :data="data[indextr].clinicHospital">
                                {{data[indextr].clinicHospital}}
                            </vs-td>
                            <vs-td :data="data[indextr].inPatientIndicator">
                                <vs-checkbox v-model="data[indextr].inPatientIndicator" disabled="true" />
                            </vs-td>
                            <vs-td :data="data[indextr].complaint">
                                {{ data[indextr].complaint }}
                            </vs-td>
                            <vs-td :data="data[indextr].diagnosis">
                                {{ data[indextr].diagnosis }}
                            </vs-td>
                            <vs-td :data="data[indextr].medicalProcedureId">
                                {{ medicalProcedureName(data[indextr].medicalProcedureId).medicalProcedureName }}
                            </vs-td>
                            <vs-td :data="data[indextr].results">
                                {{ data[indextr].results }}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{ data[indextr].remarks }}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD MEDICAL INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Medical Information"
                accept-text= "Submit"
                @accept="onAddMedical"
                :is-valid="validForm"
                :active.sync="activePromptNewMedical">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Date</span><span style="color:red">*</span>
                        <datepicker name="dateMedical-name" class="w-full" v-model="dateMedical" placeholder="Select Date" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">No Of Days</span><span style="color:red">*</span>
                         <vs-input v-validate="'numeric|max:3'" name="no of days" class="w-full" v-model="noofDays" placeholder="No of Days"/>
                         <span class="text-danger text-sm" v-show="errors.has('no of days')">{{ errors.first('no of days') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Doctor's Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="doctor name" class="w-full" v-model="doctorName"  placeholder="Name of the Doctor" />
                        <span class="text-danger text-sm" v-show="errors.has('doctor name')">{{ errors.first('doctor name') }}</span>
                    </div>
                </div>
                
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Hospital / Clinic</span><span style="color:red">*</span>
                        <vs-input name="clinicHospital-name" class="w-full" v-model="clinicHospital" placeholder="Name of the clinic/hospital" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <!-- <span  class="text-sm">Superior Name</span> -->
                        <vs-checkbox name="inPatientIndicator-name" class="w-full" v-model="inPatientIndicator">In-Patient?</vs-checkbox>
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Complaints</span>
                        <vs-input name="complaint-name" class="w-full" v-model="complaint"  placeholder="Complaints"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Diagnosis</span>
                        <vs-input name="diagnosis-name" class="w-full" v-model="diagnosis" placeholder="Diagnosis" />
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Medical Procedure</span>
                        <v-select name="medicalProcedure-name" class="w-full" v-model="medicalProcedure" label="medicalProcedureName" :options="medicalProcedureLookup" placeholder="Please select" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Results</span>
                        <vs-input name="results-name" class="w-full" v-model="results" placeholder="Results" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
               

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT MEDICAL INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Medical Information"
                accept-text= "Submit"
                @accept="onEditMedical"
                :is-valid="validForm"
                :active.sync="activePromptEditMedical">
                <vx-card title="Fill-out the following information">


               
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Date</span><span style="color:red">*</span>
                        <datepicker name="dateMedical-name" class="w-full" v-model="dateMedical" placeholder="Select Date" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">No Of Days</span><span style="color:red">*</span>
                         <vs-input v-validate="'numeric|max:3'" name="no of days" class="w-full" v-model="noofDays" placeholder="No of Days"/>
                         <span class="text-danger text-sm" v-show="errors.has('no of days')">{{ errors.first('no of days') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Doctor's Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="doctor name" class="w-full" v-model="doctorName"  placeholder="Name of the Doctor" />
                        <span class="text-danger text-sm" v-show="errors.has('doctor name')">{{ errors.first('doctor name') }}</span>
                    </div>
                </div>
                
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Hospital / Clinic</span><span style="color:red">*</span>
                        <vs-input name="clinicHospital-name" class="w-full" v-model="clinicHospital" placeholder="Name of the clinic/hospital" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <!-- <span  class="text-sm">Superior Name</span> -->
                        <vs-checkbox name="inPatientIndicator-name" class="w-full" v-model="inPatientIndicator">In-Patient?</vs-checkbox>
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Complaints</span>
                        <vs-input name="complaint-name" class="w-full" v-model="complaint"  placeholder="Complaints"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Diagnosis</span>
                        <vs-input name="diagnosis-name" class="w-full" v-model="diagnosis" placeholder="Diagnosis" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Medical Procedure</span>
                         <v-select name="medicalProcedure-name" class="w-full" v-model="medicalProcedure" label="medicalProcedureName" :options="medicalProcedureLookup" placeholder="Please select" />
                   </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Results</span>
                        <vs-input name="results-name" class="w-full" v-model="results" placeholder="Results" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
                 
            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            dateMedical         : '',
            doctorName          : '',
            noofDays            : '',
            clinicHospital      : '',
            fromDate            : null,
            toDate              : null,
            inPatientIndicator  : false,
            complaint           : '',
            diagnosis           : '',
            medicalProcedure    : null,
            results             : '',
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewMedical    : false,
            activePromptEditMedical    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
             this.$store.dispatch('lookup/getAllMedicalProcedureLookup').catch((err) => { console.log(err) })
            this.uid = this.$route.params.id
            this.employeeMedical = this.uid
            
    },
    computed: {
        employeeMedical: {
           
           get() { return this.$store.state.hrms.employeeMedical },
           set(value) { this.$vs.loading()
                        this.$store.dispatch('hrms/getAllMedical',  value )
                                .then((res) => { this.$vs.loading.close() })
                                .catch((err) => { this.$vs.loading.close()
                                                console.log(err) })
            }
            
        },
        validForm(){
            return this.dateMedical != null &&
            this.noofDays > 0 && this.doctorName != '' && this.clinicHospital != ''
        },
        medicalProcedureLookup() {
            return this.$store.state.lookup.getAllMedicalProcedureLookup 
        },
        medicalProcedureName() {
            return (id) => this.$store.getters['lookup/medicalProcedureLookup'](id)
        }
       
    },
    methods: {
        promptAddNewMedical() {
            this.activePromptNewMedical = true
        },
        onAddMedical() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    dateMedical             : this.dateMedical,
                    noofDays                : this.noofDays,
                    doctorName              : this.doctorName,
                    clinicHospital          : this.clinicHospital,
                    inPatientIndicator      : this.inPatientIndicator,
                    complaint               : this.complaint,
                    diagnosis               : this.diagnosis,
                    medicalProcedureId      : this.medicalProcedure.medicalProcedureId,
                    results                 : this.results,
                    remarks                 : this.remarks,
                    userId                  : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                //console.log(data)
                this.$store.dispatch('hrms/AddMedical', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Medical Information Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditMedical() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                      : this.id,
                    dateMedical             : this.dateMedical,
                    noofDays                : this.noofDays,
                    doctorName              : this.doctorName,
                    clinicHospital          : this.clinicHospital,
                    inPatientIndicator      : this.inPatientIndicator,
                    complaint               : this.complaint,
                    diagnosis               : this.diagnosis,
                    medicalProcedureId      : this.medicalProcedure.medicalProcedureId,
                    results                 : this.results,
                    remarks                 : this.remarks,
                    userId                  : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateMedical', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Medical Information Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeMedical'](Id)
            this.id             = e.id,
            this.dateMedical            = e.dateMedical,
            this.noofDays               = e.noofDays,
            this.doctorName             = e.doctorName,
            this.clinicHospital         = e.clinicHospital,
            this.inPatientIndicator     = e.inPatientIndicator,
            this.complaint              = e.complaint,
            this.diagnosis              = e.diagnosis,
            this.medicalProcedure       = this.medicalProcedureName(e.medicalProcedureId),
            this.results                = e.results,
            this.remarks                = e.remarks,
            this.userId                 = e.userId

            this.activePromptEditMedical = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteMedical', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeMedical = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Medical Information Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>